// Money documents inside the accounts module (HANDOFF §3):
//   «السندات»     /accounts/vouchers            manager+ (list routes are manager+)
//   «الصناديق»    /accounts/cash                every member (staff: own till → its day)
//   (till day)    /accounts/cash/:tillId        every member (erp-core: cashier, own till for staff)
//   «المصروفات»   /accounts/expenses            manager+ (HANDOFF §9)
// Panels open on any of these routes with `?panel=` (lib/links.ts). Module
// flag erp.accounts: off ⇒ absent everywhere, a deep link lands on «اليوم».

import type { RouteObject } from 'react-router-dom';
import { gate, type MenuItem } from '@/app/module-types';
import { CASH_PATH, EXPENSES_PATH, VOUCHERS_PATH } from './lib/links';

const manager = gate({ flag: 'erp.accounts', minRole: 'manager' });
const member = gate({ flag: 'erp.accounts', minRole: 'staff' });

export const vouchersRoutes: RouteObject[] = [
  { path: VOUCHERS_PATH, lazy: () => import('./screens/Vouchers').then((m) => ({ Component: m.VouchersRoute })), handle: manager },
  { path: CASH_PATH, lazy: () => import('./screens/Tills').then((m) => ({ Component: m.TillsRoute })), handle: member },
  { path: `${CASH_PATH}/:tillId`, lazy: () => import('./screens/CashDay').then((m) => ({ Component: m.CashDayRoute })), handle: member },
  { path: EXPENSES_PATH, lazy: () => import('./screens/Expenses').then((m) => ({ Component: m.ExpensesRoute })), handle: manager },
];

/** HANDOFF §3 order: كشوف الحسابات · الفواتير · السندات · الصناديق · الذمم · ذمم الموردين · الأقساط · المصروفات · … */
export const vouchersMenu: MenuItem[] = [
  { key: 'vouchers', label: 'السندات', to: VOUCHERS_PATH, flag: 'erp.accounts', minRole: 'manager' },
  { key: 'cash', label: 'الصناديق', to: CASH_PATH, flag: 'erp.accounts', minRole: 'staff' },
];

export const expensesMenu: MenuItem[] = [{ key: 'expenses', label: 'المصروفات', to: EXPENSES_PATH, flag: 'erp.accounts', minRole: 'manager' }];

// Panels other items host (statement, receivables, invoice, today):
export { ReceiptVoucherPanel } from './components/ReceiptVoucherPanel';
export type { ReceiptVoucherPanelProps } from './components/ReceiptVoucherPanel';
export { PaymentVoucherPanel } from './components/PaymentVoucherPanel';
export type { PaymentVoucherPanelProps } from './components/PaymentVoucherPanel';
export { ReceiptView, PaymentView } from './components/VoucherView';
export { PanelHost } from './components/PanelHost';
export {
  VOUCHERS_PATH,
  EXPENSES_PATH,
  CASH_PATH,
  PANEL_RECEIPT,
  PANEL_PAYMENT,
  cashDayPath,
  receiptVoucherHref,
  receiptVoucherViewHref,
  paymentVoucherHref,
  paymentVoucherViewHref,
} from './lib/links';
export type { ReceiptPrefill, PaymentPrefill } from './lib/links';
